import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.3335 8H12.6668M3.3335 8L7.3335 4M3.3335 8L7.3335 12",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowLeft;
